import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

import ScrollToTop from "../../components/ScrollTop";
import DownloadApp from "../home/DownloadApp";
import ProfileMain from "./ProfileMain";
import Breadcrumb from "../../components/Breadcrumb";

const Profile = () => {
  return (
    <>
      <Header parentMenu="profile" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="Profile" />

          <ProfileMain/>

          {/* download-app-start */}
          <DownloadApp />
          {/* download-app-end */}

          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Profile;
